import { render, staticRenderFns } from "./FavoriteWidget.vue?vue&type=template&id=b8613ab6&"
import script from "./FavoriteWidget.vue?vue&type=script&lang=js&"
export * from "./FavoriteWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports